/**
 * @name COMPARISONS
 * @const
 * @object
 * @description
 */
export const COMPARISONS = {

    /**
     * @name ALL
     * @string
     * @description Used to select all parts regardless of filter value (equivalent to having no filter)
     */
    ALL: 'select all',

    /**
     * @name EXACT
     * @number
     * @description Used to create an exact comparison
     */
    EXACT: 9,

    /**
     * @name GREATER_THAN
     * @number
     * @description Used to create a greater than (`>`) comparison
     */
    GREATER_THAN: 7,

    /**
     * @name INCLUDES
     * @number
     * @description Used to match partial string values
     */
    INCLUDES: 1,

    /**
     * @name LESS_THAN
     * @number
     * @description Used to create a less than (`<`) comparison
     */
    LESS_THAN: 6,

    /**
     * @name MAX
     * @string
     * @description Used to indicate the generic max filter value
     */
    MAX: 'max',

    /**
     * @name MIN
     * @string
     * @description Used to indicate the generic min filter value
     */
    MIN: 'min',

    /**
     * @name NONE
     * @string
     * @description Used to select no parts regardless of filter value 
     */
    NONE: 'select none'
    
};

/**
 * @name DEBOUNCE_INTERVAL
 * @constant
 * @description Time for an input to wait after the user has finished typing until the filter is applied
 */
export const DEBOUNCE_INTERVAL = 500;

/**
 * @name ERROR_CLASS
 * @constant
 * @description Class used to identify a field containing an error
 */
export const ERROR_CLASS = 'error';

/**
 * @name MAX_TYPE
 * @const
 * @description Used to reference the "max" identifier
 */
export const MAX_TYPE = COMPARISONS.MAX;

/**
 * @name MIN_TYPE
 * @const
 * @description Used to reference the "min" identifier
 */
export const MIN_TYPE = COMPARISONS.MIN;

/**
 * @name PARAMETERS_ALL
 * @const 
 * @description Used to select all parameters
 */
export const PARAMETERS_ALL = 'ALL';

/**
 * @name PARAMETERS_DEFAULT
 * @const 
 * @description Used to select default parameters
 */
export const PARAMETERS_DEFAULT = 'DEFAULT';

/**
 * @name PARAMETERS_NONE
 * @const 
 * @description Used to select no parameters
 */
export const PARAMETERS_NONE = 'NONE';

/**
 * @name SLIDER_MAX_INCREMENT
 * @const
 * @description Determines the total number of increment values a slider can have
 */
export const SLIDER_MAX_INCREMENT = 10;

/**
 * @name VALID_RANGE_FILTER
 * @constant
 * @description Tests for valid range filter string. 
 * A valid filter is described as any numeric characters of unspecified length and order with an optional decimal place, proceeded by an optional alpha character with a length of 1
 */
export const VALID_RANGE_FILTER = /^[-]{0,1}[0-9]+([.]{1}[0-9]+)?[A-Z]{0,1}$/i;

/**
 * @name INVALID_RANGE_CHARACTERS
 * @constant
 * @description Tests for invalid range filter characters. Different from `VALID_RANGE_FILTER` in that `INVALID_RANGE_CHARACTERS` does not test for correct formatting or values. Tests for characters that should never appear in any order
 */
export const INVALID_RANGE_CHARACTERS = /[!?\\{}=+]/g;

/**
 * @name EMPTY_INPUT
 * @constant
 * @description Tests if a string is empty or only whitespace
 */
export const EMPTY_INPUT = /^\s+$|^[\w]{0}$/;